export default __webpack_public_path__ + "static/media/KN.572b61dd.svg";